<template>
  <div>
    <div v-if="user.company.labels.length > 0">
      <small><b>{{ $t('b') }}</b></small>
      <ais-refinement-list
        attribute="labelIds"
        operator="and"
        :transform-items="transformItems"
        :limit="10000"
        :sort-by="refinementLabelIdsSortFunction"
      />
      <v-divider class="mt-4 mb-4"/>
    </div>
    <ais-refinement-list
      attribute="profile.skills.technicalSkillsWithText.skillNames"
      :searchable="true"
      :searchable-placeholder="$t('a')"
      operator="and"
    />
    <v-divider class="mt-4 mb-4"/>
    <algolia-filter-xpyears/>
    <v-divider class="mt-4 mb-4"/>
    <algolia-filter-languages/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AlgoliaFilterXpyears from '@/components/algolia/AlgoliaFilterXpyears'
import AlgoliaFilterLanguages from '@/components/algolia/AlgoliaFilterLanguages'

export default {
  components: {
    AlgoliaFilterXpyears,
    AlgoliaFilterLanguages,
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
  },
  methods: {
    transformItems(items) {
      return items.map(item => ({
        ...item,
        label: this.getLabelName(item.label),
      }));
    },
    getLabelName(labelId) {
      return this.user.company.labels.find(label => label.id === labelId).name
    },
    refinementLabelIdsSortFunction(a,b) {
      const labelAName = this.getLabelName(a.name).toLowerCase()
      const labelBName = this.getLabelName(b.name).toLowerCase()
      if (labelAName < labelBName) { return -1; }
      if (labelAName > labelBName) { return 1; }
      return 0;
    }
  }
}
</script>



<i18n>
{
  "fr": {
    "a": "Technologies...",
    "b": "Labels"
  },
  "en": {
    "a": "Technologies...",
    "b": "Labels"
  }
}
</i18n>